import parsePhoneNumber from "libphonenumber-js/max";

export function getEmailError(email: string) {
  const normalizedEmail = email.trim();

  if (!normalizedEmail) return "";

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)
    ? ""
    : "Enter a valid email address.";
}

export function getMobileNumberError(
  countryCode: string,
  contactNumber: string,
) {
  if (!contactNumber) return "";

  const phoneNumber = parsePhoneNumber(contactNumber, {
    defaultCallingCode: countryCode.replace("+", ""),
  });

  if (!phoneNumber?.isPossible()) {
    return "Enter a mobile number with a valid length for the selected country code.";
  }

  if (!phoneNumber.isValid()) {
    return "Enter a valid mobile number for the selected country code.";
  }

  if (phoneNumber.getType() !== "MOBILE") {
    return "Only numbers that can be verified as mobile are accepted.";
  }

  return "";
}

export function formatMobileNumber(
  countryCode: string,
  contactNumber: string,
) {
  const phoneNumber = parsePhoneNumber(contactNumber, {
    defaultCallingCode: countryCode.replace("+", ""),
  });

  return phoneNumber?.formatInternational() ?? `${countryCode} ${contactNumber}`;
}
